import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { withTheme } from '@material-ui/core';

class DimmerIcon extends PureComponent {
    static propTypes = {
        size: PropTypes.number,
        color: PropTypes.string,
        secondary_color: PropTypes.string
    };

    static defaultProps = {
        color: '#8e8e8e',
        secondary_color: '#8e8e8e',
        size: 50
    };

    render() {
        const { color, size, secondary_color } = this.props;
        return (
            <svg height={(size / 1.4).toString()} width={(size / 1.4).toString()} viewBox="0 0 300 267.64">
                <circle cx={150} cy={150} r={150} fill={color} />
                <path
                    d="M39.94 143.21c0-58 49.28-104.94 110.06-104.94S260.06 88.7 260.06 146.66c0 9-7.64 16.27-17.07 16.27s-17.07-7.29-17.07-16.27v.74c0-49-41.63-88.67-93-88.67s-93 39.7-93 88.67"
                    fill={secondary_color}
                />
                <path
                    d="M150 194.94a9.34 9.34 0 0 1-9.34-9.34v-71.2a9.34 9.34 0 1 1 18.68 0v71.2a9.34 9.34 0 0 1-9.34 9.34z"
                    fill={secondary_color}
                />
            </svg>
        );
    }
}

export default withTheme(DimmerIcon);



// WEBPACK FOOTER //
// ./data/common/iconsvg/DimmerIcon.js